module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-600italic.woff2?148405f9cdfa8278aede01cfc9b40367";